import { lazy } from "react";
import Home from "./pages/Home/Home";
import HomeCenter from "pages/HomeCenter/HomeCenter";
import SearchAllFields from "./pages/SearchAllFields";

const isForSportCenter = !!process.env.REACT_APP_CENTER_KEY;

const LANDING_ROUTES = [
  {
    path: "/",
    exact: true,
    component: isForSportCenter ? HomeCenter : Home,
  },
];

const SportCentersRoutes = [
  {
    path: "/venue/:idvenue/field/:idfield",
    exact: true,
    component: HomeCenter,
  },
  {
    path: "/venue/:idvenue",
    exact: true,
    component: HomeCenter,
  },
  {
    path: "/classes/:classId",
    exact: true,
    component: lazy(() => import("./pages/DetailsField")),
  },
];

const InnerRoutes = [
  {
    path: "classes",
    exact: true,
    component: SearchAllFields,
  },
  {
    path: "",
    exact: true,
    component: SearchAllFields,
  },
  {
    path: "profile",
    exact: true,
    component: lazy(() => import("./pages/Profile")),
  },
  {
    path: "fields/:fieldId",
    exact: true,
    component: lazy(() => import("./pages/DetailsField")),
  },
  {
    path: "classes/:classId",
    exact: true,
    component: lazy(() => import("./pages/DetailsField")),
  },
  {
    path: "classes/fields/:fieldId",
    exact: true,
    component: lazy(() => import("./pages/DetailsField")),
  },
  {
    path: "sportscenter",
    exact: true,
    component: lazy(() => import("./pages/SportCenters")),
  },
  {
    path: "sportscenter/:sportcenterId",
    exact: true,
    component: lazy(() => import("./pages/DetailsCenter")),
  },
  {
    path: "sportscenter/:sportcenterId/venue/:idvenue/field/:idfield",
    exact: true,
    component: lazy(() => import("./pages/DetailsCenter")),
  },
  {
    path: "sportscenter/:sportcenterId/venue/:idvenue",
    exact: true,
    component: lazy(() => import("./pages/DetailsCenter")),
  },
];

export { LANDING_ROUTES, InnerRoutes, SportCentersRoutes };
